import React, { useState } from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../MyPage.js";
import SubTabsWarehouses from "../../SubTabsWarehouses.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axios from 'axios';

export default function InputPoDelay({key, month, monthInput, setMonthInput, poValidated, setPoValidated, setMonthCheckbox, monthCheckbox}) {

    return (
      <div>
        <div className="row">
            <div className="col">
                <div className="input-group mb-3">
                <span className="input-group-text" style={{ fontSize: "12px" }}>{month}</span>
                <input type="text" className="form-control" 
                        style={{ fontSize: "12px" }} 
                        value={monthInput}
                        onChange={(e) =>{
                            setMonthInput(e.target.value);
                            if(!e.target.value)
                                setMonthCheckbox(e.target.checked);
                        }
                        }
                         />
                </div>
            </div>
            <div className="col">
            <div className="input-group mb-3">
                    <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
                    <input
                        id={`checkbox-${key}`}
                        type="checkbox"
                        checked={monthCheckbox}
                        onChange={(e) => {
                            setMonthCheckbox(e.target.checked);
                           }
                         }
                        disabled={ !monthInput }
                        className="form-check-input"
                        style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
                    />
                </div>
            </div>
        </div>
      </div>
    );
}
